"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFrontConfig = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var next_intl_1 = require("next-intl");
var useFrontConfig = function () {
    var lang = (0, next_intl_1.useLocale)();
    var _a = (0, useQuery_1.useQuery)({
        path: keys_1.GET_CONFIG,
        payload: {
            lang: lang,
        },
    }), data = _a.data, error = _a.error, isLoading = _a.isLoading;
    return (0, react_1.useMemo)(function () { return ({
        data: (data === null || data === void 0 ? void 0 : data.data) || [],
        isLoading: isLoading,
        error: error,
    }); }, [data, isLoading, error]);
};
exports.useFrontConfig = useFrontConfig;
